import { render, staticRenderFns } from "./DesktopNavigation.vue?vue&type=template&id=12a6a914&scoped=true&"
import script from "./DesktopNavigation.vue?vue&type=script&lang=js&"
export * from "./DesktopNavigation.vue?vue&type=script&lang=js&"
import style0 from "./DesktopNavigation.vue?vue&type=style&index=0&id=12a6a914&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a6a914",
  null
  
)

export default component.exports